var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 3.75C11.025 3.75 3.75 11.025 3.75 20C3.75 28.975 11.025 36.25 20 36.25C28.975 36.25 36.25 28.975 36.25 20C36.25 11.025 28.975 3.75 20 3.75ZM19.1167 27.1333C19.351 27.3674 19.6687 27.4989 20 27.4989C20.3313 27.4989 20.649 27.3674 20.8833 27.1333L25.8833 22.1333C26.0061 22.0189 26.1046 21.8809 26.173 21.7276C26.2413 21.5742 26.278 21.4087 26.281 21.2409C26.2839 21.073 26.2531 20.9063 26.1902 20.7507C26.1273 20.595 26.0338 20.4536 25.9151 20.3349C25.7964 20.2162 25.655 20.1227 25.4993 20.0598C25.3437 19.9969 25.177 19.9661 25.0091 19.969C24.8413 19.972 24.6758 20.0087 24.5224 20.077C24.3691 20.1454 24.2311 20.2439 24.1167 20.3667L21.25 23.2333V13.75C21.25 13.4185 21.1183 13.1005 20.8839 12.8661C20.6495 12.6317 20.3315 12.5 20 12.5C19.6685 12.5 19.3505 12.6317 19.1161 12.8661C18.8817 13.1005 18.75 13.4185 18.75 13.75V23.2333L15.8833 20.3667C15.6464 20.1459 15.333 20.0257 15.0091 20.0314C14.6853 20.0371 14.3763 20.1683 14.1473 20.3973C13.9183 20.6263 13.7871 20.9353 13.7814 21.2591C13.7757 21.583 13.8959 21.8964 14.1167 22.1333L19.1167 27.1333Z",
    fill: "#142038"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.6ffddeddb55c9b7fa4c15cd4edc6fd6e.svg";
export { ForwardRef as ReactComponent };